import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-schedule",
  "use": "icon-schedule-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-schedule\"><path d=\"M640 736a128 128 0 0 1 123.968 96H960v64l-196.032 0.064A128 128 0 0 1 640 992H576a128 128 0 0 1-123.968-95.936L64 896v-64h388.032A128 128 0 0 1 576 736h64z m0 64H576a64 64 0 0 0-7.488 127.552L576 928h64a64 64 0 0 0 0-128zM384 384a128 128 0 0 1 123.968 96H960v64l-452.032 0.064A128 128 0 0 1 384 640H320a128 128 0 0 1-123.968-95.936L64 544v-64h132.032A128 128 0 0 1 320 384h64z m0 64H320a64 64 0 0 0-7.488 127.552L320 576h64a64 64 0 1 0 0-128z m320-416A128 128 0 0 1 827.968 128H960v64l-132.032 0.064A128 128 0 0 1 704 288h-64a128 128 0 0 1-123.968-95.936L64 192V128h452.032A128 128 0 0 1 640 32h64z m0 64h-64a64 64 0 0 0-7.488 127.552L640 224h64a64 64 0 0 0 0-128z\" p-id=\"15969\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/schedule.svg
// module id = qh1b
// module chunks = 215